import { Component, effect, inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '../../services/auth.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
  selector: 'taly-user-idle',
  templateUrl: './user-idle.component.html',
  styleUrls: ['./user-idle.component.scss'],
  standalone: false,
})
export class UserIdleComponent {
  trasferSignal = inject(SharedSignalsService);
  private confirmationService = inject(ConfirmationService);
  public authService = inject(AuthService);
  public storageService = inject(LocalStorageService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  timer: number = 0;

  constructor() {
    effect(() => {
      const showPopup: boolean = this.trasferSignal?.showTimeOutPopup();
      if (showPopup) {
        this.confirmDialog();
      }
      this.timer = this.trasferSignal.sessionTimer();
    });
  }

  confirmDialog() {
    this.confirmationService.confirm({
      message:
        this.timer == 0
          ? 'Your session has expired.'
          : ` Your session is expire in ${this.timer} second( s).`,
      defaultFocus: 'none',
      acceptIcon: 'none',
      rejectIcon: 'none',
      accept: () => {
        this.trasferSignal.setTimeOutPopup(false);
        this.refrestToken();
      },
      reject: () => {
        this.trasferSignal.setTimeOutPopup(false);
        this.router.navigate(['/'], { relativeTo: this.activatedRoute });
      },
    });
  }

  refrestToken() {
    this.authService.refreshToken().subscribe({
      error: (err) => {
        this.authService.showMessage('error', err?.message || err);
      },
      complete: () => {
        // Optional: logic when observable completes
      },
    });
  }
}
